import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./styles/PosLogin.module.css";
import DataContext from "../../../context/DataContext";
import Spinner from "../../../components/ui/spinner/Spinner";
import LogInForm from "./LogInForm";
import AuthContext from "../../../context/AuthContext";
import useCurrentBU from "../../../hooks/useCurrentBU";
import POSDataContext from "../../../context/POSDataContext";

/**
 * Home page and login for POS
 */
const PosLogin = () => {
    const {
        serviceData, // {Function} - Fetches service data
        isServiceDataAvailable, // {Boolean} - Flag to check if service data is available
        setIsServiceDataAvailable, // {Function} - Sets service data availability flag
        isLoading, // {Boolean} - Flag to check if the page is loading dataCotext
        setIsServerDown,
        isServerDown,
        JWTToken,
    } = useContext(DataContext);
    const { isLoadingPos } = useContext(POSDataContext);

    // Get URL parameters
    const { user } = useContext(AuthContext);
    const [notReadyView, setNotReadyView] = useState(true);
    const navigate = useNavigate();
    const { bUser } = useParams();
    useCurrentBU(bUser);

    // Set defaults
    useEffect(() => {
        setIsServiceDataAvailable(false);
        setIsServerDown(false);
    }, []);

    // Redirect to POS tickets page if authenticated user and business user are available
    useEffect(() => {
        if (user && bUser) {
            navigate(`/${bUser}/pos/tickets`);
        }
    }, [user, bUser]);

    // Fetch service data
    useEffect(() => {
        if (bUser && JWTToken) {
            serviceData(bUser);
        }
    }, [bUser, JWTToken, user]);

    // Check ready for viewing
    useEffect(() => {
        if (isServiceDataAvailable && (!isLoadingPos || !isLoading)) {
            const timer = setTimeout(() => {
                setNotReadyView(false);
            }, 50);

            // Cleanup function
            return () => {
                clearTimeout(timer);
            };
        }
    }, [isServiceDataAvailable, isLoadingPos, isLoading]);

    return (
        <>
            <article className={` main-page-container flex-container `}>
                <section
                    className={`${styles.main_page_container} main-container flex-container `}
                >
                    {isLoadingPos ||
                    isLoading ||
                    (!isServerDown && !isServiceDataAvailable) ? (
                        <div
                            className={` ${styles.spinner_container} flex-container `}
                        >
                            <Spinner />
                        </div>
                    ) : (
                        <div
                            className={` transition-container 
                    ${
                        notReadyView
                            ? "transition-hidden"
                            : "transition-visible"
                    }   main-page-container flex-container`}
                        >
                            {isServiceDataAvailable ? <LogInForm /> : <></>}
                        </div>
                    )}
                </section>
            </article>
        </>
    );
};

export default PosLogin;
